import { useMediaQuery, useTheme } from "@mui/material";
import {
  Box,
  Button,
  Color,
  Modal,
  OutlineArrowRightIcon,
  OutlineXmarkIcon,
  Spacing,
  Typography,
} from "kvweb-ui";
import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../store/hooks";
import { ShopInformation } from "../../../store/slices/shopSlice";
import { useTranslation } from "react-i18next";
import { getPlatform } from "../../../utils/helper";
import {
  BOOKING_HOTEL_PLATFORM,
  BOOKING_PLATFORM,
} from "../../../utils/constant";
import { useAdminMerchantContext } from "../../../contexts/adminMerchant/adminMerchant.context";
type Props = {};
const ModalUpgradeSubscriptonSuccess = (props: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const {retail} = useAdminMerchantContext();
  const [isOpen, setIsOpen] = useState(false);
  const shopInfo = useAppSelector(ShopInformation);
  const { t } = useTranslation();
  const platform = getPlatform();
  const handleCloseModal = () => {
    setIsOpen(!isOpen);
  };

  function generateTextWelcome() {
    let text = "";
    switch (platform) {
      case BOOKING_PLATFORM:
        text = t("SUBSCRIPTIONS.BOOKING_CONGRATUATIONS_UPGRADE_SUCCESS");
        break;
      case BOOKING_HOTEL_PLATFORM:
        text = t("SUBSCRIPTIONS.HOTEL_CONGRATUATIONS_UPGRADE_SUCCESS");
        break;
      default:
        text = t("SUBSCRIPTIONS.CONGRATUATIONS_UPGRADE_SUCCESS");
    }
    return text;
  }

  useEffect(() => {
    if (shopInfo.isShopUpgradePackageSuccess) {
      setIsOpen(true);
    }
  }, [shopInfo]);
  return (
    <>
      <Modal
        open={isOpen}
        onClose={handleCloseModal}
        sxDialog={{
          padding: Spacing["space-xl"],
          position: "relative",
        }}
      >
        <Box
          sx={{
            textAlign: "center",
          }}
        >
          <img
            style={{
              margin: `0px auto ${retail.is_keivi_region ? '-50px' : '0'} auto`,
              height: isMobile ? '220px' : '260px',
            }}
            src={retail.is_keivi_region ? '/img/retail/keivi-upgrade-success.png' : '/img/retail/upgrade-success.png'}
          />
          <Box
            sx={{
              width: "fit-content",
              position: "absolute",
              top: 20,
              right: 20,
              cursor: "pointer",
            }}
            onClick={handleCloseModal}
          >
            <OutlineXmarkIcon />
          </Box>
          <Box
            sx={{
              marginBottom: Spacing["space-xl"],
            }}
          >
            <Typography
              textType="text20S"
              color={Color["black-850"]}
              sx={{
                marginY: Spacing["space-l"],
              }}
            >
              {t("COMMON.PACKAGE.WELCOME_TO_KVWEB")}
            </Typography>
            <Typography textType="text14R" color={Color["black-750"]}>
              {generateTextWelcome()}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Button
            btnType="solid"
            endIcon={<OutlineArrowRightIcon />}
            onClick={handleCloseModal}
            sx={{
              [theme.breakpoints.down("md")]: {
                width: "100%",
              },
            }}
          >
            {t("MY_WEBSITE.BUTTON.START_NOW")}
          </Button>
        </Box>
      </Modal>
    </>
  );
};
export default ModalUpgradeSubscriptonSuccess;
